import { constructAsync } from '../../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../../webmodule-common/other/dispose';
import { FranchiseeFabricationJobListView } from '../views/franchisee-fabrication-job-list-view';
import { html } from 'lit';
import { LangAppFabricationJobsPage } from '../../../../localization/scripts/dealer-franchisee/fabrication-jobs/pages/app-fabrication-jobs-lang';
import { TabbedPageBase } from '../../pages/helpers/page-base';
import { userDataStore } from '../../common/current-user-data-store';

@customElement('app-fabrication-jobs')
export class AppFabricationJobsPage extends TabbedPageBase {
  @state()
  private listView: FranchiseeFabricationJobListView | null = null;

  constructor() {
    super();
  }

  protected async setActiveTabByHash() {
    await this.listView?.setActiveTabByHash();
  }

  render() {
    if (!this.loggedIn) return html``;
    return html`
      <div class="page-content">
        <div class="page-container">${this.listView?.ui}</div>
      </div>
    `;
  }

  meta() {
    return {
      title: () => LangAppFabricationJobsPage.fabricationJobsTitle(),
      description: LangAppFabricationJobsPage.fabricationJobsDescription()
    };
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async afterUserConnected() {
    this.listView = new FranchiseeFabricationJobListView({
      branchId: async () => {
        await userDataStore.loadCoreDetails();
        return userDataStore.defaultBranch?.id ?? '';
      }
    });
    await constructAsync(this.listView);
    await super.afterUserConnected();
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.listView);
    this.listView = null;
  }
}
